@for (evidence of evidenceList; track evidence) {
  <div class="fields">
    <div class="field-container">
      <div class="field-key">Found in</div>
      <div class="field-value-container">
        <app-anchor-link navigation="" (clicked)="openEvidence(evidence)">
          <span appLongTextTooltip class="field-link-value__text">
            {{ getStepType(evidence) | beautifyDisplayString }}
          </span>
        </app-anchor-link>
        {{ getLocation(evidence) }}
      </div>
    </div>
    <div class="field-container">
      <div class="field-key">Core Evidence</div>
      <div class="field-value-container">
        @if (isSensitiveContent(evidence)) {
          <div class="field-value-transcript">
            <div class="field-value-transcript-string" [innerHtml]="getCoreEvidence(evidence)"></div>
            <app-get-sensitive-data-input-action
              *ngIf="isSensitiveContent(evidence)"
              [sensitiveDataMethod]="getSensitiveDataMethod(evidence)"
              [showPopupBtn]="true"
              [content]="''"
              [sensitiveDataIndexes]="getEvidenceSensitiveIndexes(evidence)"
            >
            </app-get-sensitive-data-input-action>
          </div>
        } @else {
          <div class="field-value" [innerHtml]="getCoreEvidence(evidence)"></div>
        }
      </div>
    </div>
    @if (isFileContentEvidence(evidence)) {
      <div class="field-container">
        <div class="field-key">{{ 'evidenceListPage.attachedFiles' | labelsProvider }}</div>
        <div class="field-value-container attachments-container">
          @for (attachment of getAttachedDocuments(evidence); track attachment.id) {
            <app-badge>
              <img badge-left src="assets/images/common/file.svg" alt="File" />
              {{ attachment.displayName }}
              <button
                badge-right
                class="attachment-download-button"
                (click)="downloadAttachment(evidence, attachment)"
                [matTooltip]="'evidenceListPage.downloadTooltip' | labelsProvider"
              >
                <img src="assets/images/common/export.svg" alt="Download" />
              </button>
            </app-badge>
          }
        </div>
      </div>
    }
  </div>
}
